<div class="time-remain col-md-12 text-center" *ngIf="sessionExpirationTime > 0">
  <div class="time-hour"><span>{{timerMinutes}}</span>:{{timerSecondes}}</div>
  <div class="time-message">{{'front_booking.Time_tunnel'| translate}}</div>
</div>


<div class="text-center" *ngIf="sessionExpirationTime <= 0" style="margin-bottom: 53px;">

  <div class="sessionexpiredMessage col-md-12 text-center" >
    <div class="sessionExpired-first-line">{{'front_booking.sorry'| translate}}</div>
    <div class="sessionExpired-second-line">{{'front_booking.Your_session_has_expired'| translate}}</div>
  </div>

  <a   href="{{currenteventUrl}}"  title="Retour évènement" class="btn inline-block  createBtn" style=""> {{'front_booking.go_back_to_event'| translate}}</a>
</div>
